const style = `
  <style>
    .filter-products {
        max-width: 1200px;
        margin: 0 auto;
        padding: 20px;
    }

    .filters-container {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 26px;
        font-weight: 400;
        vertical-align: middle;
        flex-wrap: wrap;
        line-height: 1.5;
    }

    .filter-wrapper {
        padding: 20px;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 22px;
    }

    .filter-form {
        display: flex;
        flex-wrap: wrap;
        gap: 15px;
        align-items: end;
    }

    .filter-field {
        display: flex;
        padding: 8px;
        gap: 22px;
    }

    .filter-label {
        display: block;
        margin-bottom: 5px;
        font-weight: 600;
        color: #333;
    }

    .filter-input,
    .filter-select {
        border: none;
        font-size: 20px;
        background: transparent;
        padding: 0px 10px 0px 0px;
        font-weight: 400;
        line-height: 100%;
        vertical-align: middle;
        color: #4CBEA7;
        outline: none;
        display: none
    }

    .filter-input:focus,
    .filter-select:focus {
        outline: none;
        border: none;
    }

    .filter-button {
        border-color: #000000;
    }

    .reset-button {
        background: transparent;
        text-decoration: underline !important;
    }

    .text-button {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .filter-clear {
        display: inline-block;
        color: #666;
        text-decoration: none;
        font-size: 14px;
        padding: 10px 0;
    }

    .filter-clear:hover {
        color: #333;
        text-decoration: underline;
    }

    .search-results-title {
        margin-bottom: 20px;
        color: #333;
    }

    .products-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
        gap: 20px;
        margin-bottom: 30px;
    }

    .product-card {
        border: 1px solid #eee;
        border-radius: 8px;
        overflow: hidden;
        transition: transform 0.2s, box-shadow 0.2s;
    }

    .product-card:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }

    .product-link {
        text-decoration: none;
        color: inherit;
    }

    .product-image {
        aspect-ratio: 1;
        overflow: hidden;
    }

    .product-image img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .product-placeholder {
        width: 100%;
        height: 100%;
        background: #f5f5f5;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .product-info {
        padding: 15px;
    }

    .product-title {
        margin: 0 0 10px 0;
        font-size: 16px;
        font-weight: 600;
        color: #333;
    }

    .product-price {
        margin: 0;
        font-size: 14px;
    }

    .product-price-regular {
        color: #666;
    }

    .product-price-sale {
        color: #e74c3c;
        font-weight: 600;
    }

    .pagination {
        text-align: center;
        margin-top: 30px;
    }

    .no-results {
        text-align: center;
        margin-top: 20px;
    }
    .hide {
        display: none;
    }
    
    @media (max-width: 768px) {
        .filter-form {
        flex-direction: column;
        }
        
        .filter-field {
            min-width: auto;
            padding: 0px;
        }
        
        .products-grid {
        grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
        gap: 15px;
        }
        
        .filter-wrapper {
            padding: 0px;
        }
            
        .text-button {
            font-size: 11px;
        }

        .reset-button {
            font-size: 11px;
        }
    }
    @media (min-width: 769px) {
      .filters-container {
        font-size: 30px;
        line-height: 100%;
      }

      .filter-wrapper {
            gap: 6px;
      }
    }
    </style>
`;

export { style };
